// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/mutation-create-claim.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateClaim($claim: jsonb, $current_location_id: numeric!) {
  payments_create_claim(
    args: { claim: $claim, current_location_id: $current_location_id }
  ) {
    id
  }
}

`